function ivaAvailability(appConfig) {
    if (!window.NITGlobal) {
        window.NITGlobal = { clientAvailable: false };
    }
    if (!appConfig.isMobile) {
        window.NITGlobal.clientAvailable = true;
    }
    else {
        const isRCAvailable = appConfig['IvaAvailability.RCMobileWeb'] === "True";
        const isPSCCAvailable = appConfig['IvaAvailability.PSCCMobileWeb'] === "True";
        if (appConfig.main.platform === "PSCC") {
            window.NITGlobal.clientAvailable = isPSCCAvailable;
        }
        else if (appConfig.main.platform === "RC") {
            const clientName = appConfig.clientName;
            const clientsJSON = appConfig['IvaAvailability.MobileWebClients'];
            const clients = JSON.parse(clientsJSON);
            // In case client not available in list, change undefined to false
            window.NITGlobal.clientAvailable = isRCAvailable && !!(clientName && clients[clientName]);
        }
        else {
            window.NITGlobal.clientAvailable = true;
        }
    }
}
export default ivaAvailability;
